import {fetchChat, fetchUnreadChat} from '../store/slices/chat_slice';
import {store as AppStore} from '../store/store';

export async function chatLoader(store: typeof AppStore) {
    const token = store.getState().exchangeToken.token;
    if (token) {
        const result = await store.dispatch(fetchChat({token}));

        return result;
    }
    return null;
}

export async function unreadChatLoader(store: typeof AppStore) {
    const token = store.getState().exchangeToken.token;
    if (token) {
        const result = await store.dispatch(fetchUnreadChat({token}));

        return result;
    }
    return null;
}
